import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { CanvasGroupComponent } from "./canvas-group/canvas-group";
import { CanvasComponent } from "./canvas/canvas";

@NgModule({
  declarations: [CanvasComponent, CanvasGroupComponent],
  imports: [IonicModule, TranslateModule.forChild()],
  exports: [CanvasComponent, CanvasGroupComponent],
})
export class CanvasModule {}



// WEBPACK FOOTER //
// ./src/components/configurable/canvas/canvas.module.ts